module.exports = __webpack_public_path__ + "static/media/pathways.1f49e881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/pathways.png
// module id = 1080
// module chunks = 0